import { createStyles } from 'antd-style'

export const editorStyles = createStyles(
  ({ token }, props: { height?: number }) => ({
    editor: {
      '.ql-toolbar': {
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        borderColor: token.grey.grey3
      },
      '.ql-container': {
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
        borderColor: token.grey.grey3,
        height: props.height ?? 88,
        fontWeight: 500,
        fontSize: 14
      },
      '.ql-editor.ql-blank::before': {
        fontWeight: 500,
        fontSize: 14,
        fontStyle: 'unset'
      }
    }
  })
)
